'use client'

import { useEffect, useState } from 'react'
import { Loader2 } from 'lucide-react'
import { Input } from '@/components/ui/input'
import type { ProcessedTheme } from '../ProcessedEntry/DomainEntry/processedTypes'
import { watchClasses } from '../ProcessedEntry/DomainEntry/processedTypes'

// Corrects user_entries.source — the free-text ingestion-channel field
// unified_entries_flat exposes as `source` (see that view's `ue.source`),
// which is what the Unified Entries table's "Source" column shows. Not the
// sources catalog/source_id used for tenant scoping (ManageSourcesView).
//
// Unlike AssignFieldsWidget/EditInputWidget, this doesn't stage into
// fieldOverrides for a later Accept — source lives on user_entries
// independent of whether the entry has reached processed_entries yet, so
// there's no accept-time moment to piggyback the write on. Saves explicitly
// via its own Save button instead.
export function SourceWidget({
  theme,
  value,
  onSave,
  saving,
}: {
  theme: ProcessedTheme
  value?: string | null
  onSave: (value: string) => void
  saving?: boolean
}) {
  const c = watchClasses(theme)
  const [draft, setDraft] = useState(value ?? '')
  useEffect(() => { setDraft(value ?? '') }, [value])
  const dirty = draft.trim() !== (value ?? '')

  return (
    <div>
      <div className={`mb-1 text-[11px] font-semibold ${c.label}`}>Source</div>
      <div className="flex gap-1.5">
        <Input
          className={`h-8 text-[12px] ${c.input}`}
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          placeholder="e.g. twitter"
        />
        <button
          type="button"
          disabled={!dirty || saving}
          onClick={() => onSave(draft.trim())}
          className={`shrink-0 rounded border px-2.5 text-[11px] font-semibold transition-colors disabled:opacity-40 ${c.line} ${c.muted}`}
        >
          {saving ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : 'Save'}
        </button>
      </div>
    </div>
  )
}
